import { Action, createReducer, on } from '@ngrx/store';

import { loadUserBenefitsSuccessAction } from '@app/store/actions/global.actions';
import { UserBenefitResponse } from '@shared/benefits/entities/benefits';

export const initialState = [];

const featureReducer = createReducer(
  initialState,
  on(loadUserBenefitsSuccessAction, (state, { benefits }) => benefits),
);

export const benefitsReducer = (state: UserBenefitResponse[], action: Action): UserBenefitResponse[] => {
  return featureReducer(state, action);
};

